<template>
<div>
  <h5 class="cabecera">Cliente</h5>
  <div class="linea">
  </div>
      <ul class="list-data">
        <li>
          <label>
            <md-icon>face</md-icon>
            {{issue.cliente.codigo}} - {{issue.cliente.nombre_busqueda}}
          </label>
        </li>
        <li>
          <label>
            <md-icon>move_to_inbox</md-icon>
            {{issue.cliente.contacto.email}}
          </label>
        </li>
        <li>
          <label>
            <md-icon>phone</md-icon>
            {{issue.cliente.contacto.telefono}}
          </label>
        </li>
      </ul>
</div>
</template>
<script>
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import { SectionPanel } from "@/components";

export default {
  name: "issue-cliente",
  components: { SectionPanel },
  props: {
    issue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.list-data {
  list-style: none;
  padding: 10px;
  margin: 0px;
}
.linea{
  border-bottom: #e0f3e7 solid 1px;
  width:100%;padding-bottom: 0px;
  margin-top: -15px;
}
.cabecera{
  padding-bottom: 0%;
  padding-left: 10px;
  padding-top: 10px;
  font-weight: bold;
  font-size: 15px;
  color:#2a6917;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 30px;
  width: 190px;
  background-color: #e0f3e7;
}
</style>


